import Image from '@components/Image'
import React, {Fragment} from 'react'
import { Col, Container, Row } from 'react-bootstrap'
import { RealEstateDataPageComponentData } from 'types'

const AboutUs10 = (props: RealEstateDataPageComponentData) => {
  const { title,paragraphs, image_gatsby } = props
  return (
    <section className="about-main ltxt p-y-config">
      <Container fluid>
        <Row className="d-flex justify-content-center">
          <Col xs={12}>
            <Row className="pt-lg-0 pt-5">
              <Col xs={{ span: 12 }}>
                <Image
                  className="w-100"
                  objectFit="cover"
                  alt="about-us-img"
                  image={image_gatsby!}
                />
              </Col>
              <Col>
              {title && <h2>{title}</h2>  }
                <p>
                  {paragraphs?.map((paragraph,index) => {
                    return <Fragment key={index}>{`${paragraph}`} <br /></Fragment>
                  })}
                </p>
              </Col>
            </Row>
          </Col>
        </Row>
      </Container>
    </section>
  )
}

export default AboutUs10
